import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { validate as uuidValidate } from 'uuid';
import { _UUID } from '../config/constantApi';

export interface Props {
    component: any;
    exact?: boolean;
    path: string;
}
const PrivateRoute: React.FC<Props> = ({
    component: Component,
    ...rest
}) => (
    <Route
        {...rest}
        render={props =>
            uuidValidate(localStorage.getItem(_UUID) as string) ? (
                <Component {...props} />
            ) :
                (
                    <Redirect to={'/'} />
                )
        }
    />
);

export default PrivateRoute;
